export default __webpack_public_path__ + "static/media/PANEL_POLITICAL_WATCH.58d9c778.png";